var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCookiesIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FF9C40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4L15 6",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H6",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41406 8L7.91406 9.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.5859L8.5 22.0859",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4L15 6",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16H24",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5859 8L22.0859 9.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.5859L21.5 22.0859",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.5714C13 11.2857 13.6599 10 15.5 10C17.3401 10 18 11.2857 18 12.5714C18 13.8571 17 14.7143 16 16C15 17.2857 15 17.7143 15 19",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9999,
    cy: 22.1,
    r: 0.6,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookiesIconActive);
export default __webpack_public_path__ + "static/media/cookies_icon--active.c86af376155edd2677fb7064d3f9756e.svg";
export { ForwardRef as ReactComponent };